"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateEmptyProduct = void 0;
const generateEmptyProduct = ()=>({
        type: 'empty'
    });
exports.generateEmptyProduct = generateEmptyProduct;
